import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { readLeadFinance } from '../../requests/lead_finance_request';
import { readLeadProfileLeadFinanceSuccess, readLeadProfileLeadFinanceFailure } from '../actions/lead_profile_lead_finance.actions';
import { READ_LEAD_PROFILE_LEAD_FINANCE } from '../constants/lead_profile_lead_finance.constants';

function* readLeadProfileLeadFinanceRequest({ params }) {
    const { result, error, options } = yield call(readLeadFinance, params);
    if (result) {
        yield put(readLeadProfileLeadFinanceSuccess(options));
    } else {
        yield put(readLeadProfileLeadFinanceFailure(error));
        message.error(error.message);
    }
}

export default function* readLeadProfileLeadFinanceSaga() {
    yield takeEvery(READ_LEAD_PROFILE_LEAD_FINANCE, readLeadProfileLeadFinanceRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/read_lead_profile_lead_finance.saga.js